import { render, staticRenderFns } from "./MoneyField.vue?vue&type=template&id=5f2fc7a4&scoped=true&"
import script from "./MoneyField.vue?vue&type=script&lang=js&"
export * from "./MoneyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2fc7a4",
  null
  
)

export default component.exports